<mat-toolbar class="subtitulo">Usuário</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <mat-horizontal-stepper #stepper style="background: transparent; padding: 10px">

        <!------------------ DADOS USUARIO ------------------------>
        <mat-step [stepControl]="formCadastroDadosUsuario">
          <form #formCadastroDadosUsuario="ngForm">
              <ng-template matStepLabel>DADOS USUARIO</ng-template>
              <dados-usuario [usuarioSistema]="usuarioSistema" [isAtualizar]="isAtualizar"></dados-usuario>

              <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
              fxFlexFill>
            <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
          </form>
      </mat-step>

        <!------------------ DADOS PESSOAIS ------------------------>
        <mat-step [stepControl]="formCadastroDadosPessoais">
            <form #formCadastroDadosPessoais="ngForm">
                <ng-template matStepLabel>DADOS PESSOAIS</ng-template>
                <dados-pessoais [pessoaFisica]="usuarioSistema.pessoaFisica"></dados-pessoais>

                <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                fxFlexFill>
              <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                  <mat-icon>chevron_right</mat-icon>
              </button>
              <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                  <mat-icon>chevron_left</mat-icon>
              </button>
          </div>
            </form>
        </mat-step>

        <!-- ------------------ DOCUMENTOS ------------------------ -->
        <mat-step style="padding-bottom: 20px" [stepControl]="formCadastroDocumentos">
            <form #formCadastroDocumentos="ngForm">
                <ng-template matStepLabel>DOCUMENTOS</ng-template>
                <documentos [pessoaFisica]="usuarioSistema.pessoaFisica"></documentos>
            </form>

            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
            fxFlexFill>
          <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
              <mat-icon>chevron_right</mat-icon>
          </button>
          <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
              <mat-icon>chevron_left</mat-icon>
          </button>
      </div>
        </mat-step>

        <!-- ------------------ UNIDADES ------------------------ -->
        <mat-step style="padding-bottom: 20px" [stepControl]="formCadastroUnidades">
            <form #formCadastroUnidades="ngForm">
                <ng-template matStepLabel>UNIDADES</ng-template>
                <unidade [usuarioSistema]="usuarioSistema"></unidade>
            </form>

            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
            fxFlexFill>
          <button mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
              <mat-icon>chevron_left</mat-icon>
          </button>
      </div>
        </mat-step>


    </mat-horizontal-stepper>
</div>

 <!-- BOTOES -->
 <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
    <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button
            name="botaoConfirmar"
            fxFlex="20%"
            color="primary"
            [disabled]="formCadastroDadosPessoais.invalid ||  formCadastroDocumentos.invalid || 
                        formCadastroDadosUsuario.invalid || formCadastroUnidades.invalid"
            (click)="cadastrar()"> Cadastrar
    </button>

    <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button
            name="botaoConfirmar"
            fxFlex="20%"
            color="primary"
            [disabled]="formCadastroDadosPessoais.invalid ||  formCadastroDocumentos.invalid || 
                        formCadastroDadosUsuario.invalid || formCadastroUnidades.invalid"
            (click)="atualizar()">
            Atualizar
    </button>

    <button *ngIf="mostrarBotaoLimpar()" 
            mat-raised-button 
            fxFlex="20%" 
            (click)="limpar()">
            Limpar
    </button>
    <button 
            mat-raised-button 
            fxFlex="20%" 
            (click)="cancelar()">
            Cancelar
    </button>

</div>
